var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecreaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.423 3.84481C6.42359 3.43239 6.74588 3.1276 7.15334 3.1276C7.56021 3.12702 7.87405 3.46944 7.87346 3.88185L7.86733 9.91964L9.53451 8.23818C9.82238 7.94651 10.2893 7.94594 10.5772 8.23761C10.8648 8.52869 10.8642 9.00147 10.576 9.29314L7.70488 12.2005L7.68446 12.2206C7.55 12.3682 7.35634 12.4604 7.14225 12.4609C6.92817 12.4609 6.73538 12.3694 6.60063 12.2218L6.5805 12.2011L3.71605 9.30103C3.42875 9.00994 3.42934 8.53714 3.7175 8.24548C4.00596 7.95264 4.47233 7.95265 4.76021 8.24373L6.41658 9.8826L6.423 3.84481Z",
    fill: "#FF5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecreaseIcon);
export default __webpack_public_path__ + "static/media/decrease_icon.ba3a85a38b0a0a612648c3542ba0329c.svg";
export { ForwardRef as ReactComponent };